import React from 'react'
import { Tag } from 'antd';

interface Props {
    status: App.ApplicationScoreLineItem['grading_progress'] | undefined;
}

/***
 * 採点中 or 採点完了 or 採点失敗 or 未採点を きれいなタグとして表示する
 * @param props
 * @constructor
 */
export const ScoringStatusTag: React.FC<Props> = (props) => {
    switch (props.status) {
        case 'PendingManual':
        case 'Pending':
            return (
                <Tag color='#AAAAAA' style={{width: '75px', textAlign: 'center', borderRadius: '5px'}}>
                    採点中
                </Tag>
            );
        case 'Failed':
            return (
                <Tag color='#AAAAAA' style={{width: '75px', textAlign: 'center', borderRadius: '5px'}}>
                    採点失敗
                </Tag>
            );
        case 'NotReady':
            return (
                <Tag color='#AAAAAA' style={{width: '75px', textAlign: 'center', borderRadius: '5px'}}>
                    未採点
                </Tag>
            );
        case 'FullyGraded':
            return (
                <Tag color='#118584' style={{width: '75px', textAlign: 'center', borderRadius: '5px'}}>
                    採点完了
                </Tag>
            );
        default:
            return null;
    }
}
